﻿import { ApiCaller } from 'apis/ApiCaller';

export interface Language {
	Id: number;
	Name: string;
}

export class LanguagesApi {

    private static apiCaller = new ApiCaller('Language');

    public static GetAll() {

	    return this.apiCaller.GET<any[]>('GetAll');

    }

}